import { message } from 'antd';
import { projectsproposal } from '@gtintel/platform-api';
import { PartnerProposalStatus } from '@gtintel/platform-types';
export function searchPartner() {
  this.setState({
    loadingPartner: true
  }, () => {
    this.getPartnerProposal();
  });
}
export function updateSearchPartnerInput(value) {
  this.setState({
    searchPartner: value
  }, () => {
    if (value === '') {
      this.getPartnerProposal();
    }
  });
}
export function selectPartner(partner, project) {
  const {
    getPartner
  } = this.state;
  this.setState({
    selectingPartner: true,
    selectPartner: partner.id,
    selectPartnerName: `${partner.first_name} ${partner.last_name}`
  });
  projectsproposal({
    project_id: this.props.query.id,
    user_id: String(partner.id)
  }).then(response => {
    if (!response.id) {
      message.error('Partner proposal failed!');
      return;
    }
    getPartner.result.forEach(partnerDetail => {
      if (partnerDetail.id === partner.id) {
        partnerDetail.proposal_status = -1;
        getPartner.result.sort((a, b) => {
          if (a.proposal_status === PartnerProposalStatus.PENDING) return -1;
          if (b.proposal_status === PartnerProposalStatus.PENDING) return 1;
          return 0;
        });
      }
    });
    this.setState({
      getPartner
    });
    this.sendNotification(false, partner?.id, partner?.full_name, project);
    message.success('Successful partner proposal!');
  }).catch(error => {
    if (error.data) {
      if (error.data.final_price) {
        message.error(error.data.final_price[0]);
      }
      if (error.data.partner_price) {
        message.error(error.data.partner_price[0]);
      }
    }
  }).finally(() => {
    setTimeout(() => {
      window.location.reload();
      this.setState({
        selectingPartner: false
      });
    }, 1000);
  });
}